import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Fruit.svg",
  "use": "Fruit.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Fruit.svg\"><path d=\"M39.0106,54.0208c-2.9139,0-4.7509-1-7-1s-4.0862,1-7,1c-4.9482,0-15-8.52-15-24,0-9.09,5.7762-15,13-15,3.9506,0,5.7425,2,9,2s5.05-2,9-2c7.2236,0,13,5.91,13,15C54.01,45.5009,43.9588,54.0208,39.0106,54.0208Zm-5-40a1.6776,1.6776,0,0,1-1.5,1c-1.137,0-1.5-.5821-1.5-2,0-3.0217,2.4535-7,5-7,1.4477,0,3,.8827,3,2C39.0106,10.0179,35.9088,10.0418,34.01,14.0209Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol